module.exports = __webpack_public_path__ + "media/store/images/variable-fonts/variable-icon-3-40d08734564f19a4961574b3fd1521e4.svg";